import mixpanel from "mixpanel-browser";
import OneSignal from "react-onesignal";
import { Analytics } from "./types";
import { buildPathWithParams } from "@/hooks";

export interface OneSignalConfig {
  appId: string;
  showPromoCode?: boolean;
  promoCodeText?: string;
}

export class OneSignalSourceProvider {
  initialized: boolean = false;
  isInitializing: boolean = false;
  latestRoute: string = "";

  initialize = (client: OneSignalClient): Analytics => {
    if (
      /**
       * This part will only work on page refresh or when we open the page directly
       * onesignal will initialize and we will add one count to the page view count
       */
      !this.initialized &&
      !this.isInitializing &&
      client.config.appId
    ) {
      this.isInitializing = true;

      OneSignal.init({ appId: client.config.appId })
        .then(() => {
          this.initialized = true;
          this.isInitializing = false;
        })
        .catch((error) => {
          console.error("Error initializing OneSignal:", error);
          this.isInitializing = false;
        });
    }

    return OneSignalAnalytics(client.config);
  };
}

export interface OneSignalClient {
  provider: "onesignal";
  config: Partial<OneSignalConfig> & { appId: string };
}

export function makeOneSignalClient(config: OneSignalConfig): OneSignalClient {
  return {
    provider: "onesignal",
    config: {
      ...config,
    },
  };
}

function OneSignalAnalytics(config: OneSignalConfig): Analytics {
  return {
    group: () => {},
    register: () => {},
    identify: () => {},
    screen: () => {
      if (!config.appId) {
        return;
      }

      const observeSubscribe = () => {
        if (config.showPromoCode && config.promoCodeText) {
          let showedToast = false;
          let email = "";

          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === "childList") {
                // this is the toast shown after user subscribes
                const toastText = document.getElementById(
                  "onesignal-toast-text"
                );
                const emailInput = document.querySelector(
                  ".onesignal-email-input"
                );

                if (emailInput) {
                  emailInput.addEventListener("input", (e) => {
                    email = (e.target as HTMLInputElement).value;
                  });
                }

                if (toastText && !showedToast && email) {
                  mixpanel.identify(email);
                  mixpanel.track("OneSignal Web Prompt Subscribed", {
                    "Promo Code Text": config.promoCodeText,
                    Email: email,
                  });
                }

                if (toastText && !showedToast && config.promoCodeText) {
                  const currentUrl = window.location.pathname;
                  const updatedUrl = buildPathWithParams(currentUrl, {
                    promoCode: config.promoCodeText,
                  });
                  window.history.replaceState(null, "", updatedUrl);
                  showedToast = true;
                  observer.disconnect();
                }
              }
            });
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true,
          });
        }
      };
      observeSubscribe();
    },
    ecommerceEvent: () => {},
    event: () => {},
  };
}
